// extracted by mini-css-extract-plugin
export default {"list":"_2NKtyM2fniKkvq6q0pT2d2"};